import { useMutation } from 'react-query';
import { axios } from '@/lib/axios';
import { MutationConfig } from '@/lib/react-query';
import { useNotificationStore } from '@/stores/notifications';
import { showNotification } from '@/utils/notificationUtils';

export type requestDTO = {

    contacts?: any
    message: string;
    isSingleMessage?: boolean;
    template?: string;
    attributeName?: string;
};

export const sendMessage = ({ contacts, message, template, attributeName, isSingleMessage= false}: requestDTO) => {
    return axios.post(`/superadmin/send-message`, { contacts, message , template, attributeName, isSingleMessage});
};

type UseAddUserOptions = {
    config?: MutationConfig<typeof sendMessage>;
};

export const useSendMessage = ({ config }: UseAddUserOptions = {}) => {
    const { addNotification } = useNotificationStore();
    return useMutation({
        onSuccess: () => {
            showNotification({
                type: 'success',
                title: 'Messsage sent successfully',
            });
        },
        ...config,
        mutationFn: sendMessage,
    });
};


export type requestDTO1 = {
    id?: any;
};

export const getTemplates = (
    { id }: requestDTO1 = {
    }
  ): Promise<any> => {
    return axios.get(`/superadmin/get-template`);
  };

type UseAddUserOptions1 = {
    config?: MutationConfig<typeof getTemplates>;
};

export const useGetTemplates = ({ config }: UseAddUserOptions1 = {}) => {
    const { addNotification } = useNotificationStore();
    return useMutation({
        onSuccess: () => {
            // showNotification({
            //     type: 'success',
            //     title: 'Messsage sent successfully',
            // });
        },
        ...config,
        mutationFn: getTemplates,
    });
};

